export function pushUserOut() {
  window.location.replace('/');
  localStorage.removeItem('sessionKey');
}
